<template>
  <!-- A duplication of VendorSelector.vue to have new styles/behavior -->
  <div class="order-0 mt-2 flex items-stretch lg:mt-0">
    <button
      id="vendorSelectorToggle"
      ref="vendorSelectorToggle"
      v-tippy="{
        html: '#vendor-selector-popover',
        interactive: true,
        reactive: true,
        trigger: 'click',
        theme: 'flush',
        placement: 'top-start',
        flipBehavior: ['top', 'bottom-end'],
      }"
      class="flex items-center text-lg outline-none leading-none text-md lg:font-medium"
    >
      <i class="md-24 mr-1">business</i>
      <span id="vendorSelectorToggle_unitName">{{ currentVendorName }}</span>
      <i id="vendorSelectorToggle_dropDown" class="md-18 ml-25">arrow_drop_down</i>
    </button>

    <!-- Dropdown Content -->
    <div v-cloak id="vendor-selector-popover" class="text-left p-2">
      <!-- Header -->
      <section-header size="sm">
        <template slot="content">
          <heading size="sm">{{ bp('selectVendor') }}</heading>
        </template>
      </section-header>

      <!-- Search Box (If needed) -->
      <div v-if="vendorList && vendorList.length >= searchDisplayThreshold">
        <label for="vendor-search" class="form-label text-md">{{ bp('searchForVendor') }}</label>
        <div class="form-group">
          <input id="vendor-search" v-model="search" type="text" class="form-control" />
          <span class="form-help">{{ bp('enterVendorName') }}</span>
        </div>
      </div>

      <!-- Scrollable vendor list -->
      <div v-if="filteredVendorList && filteredVendorList.length" class="b2b-scroll-list-container min-w-xs">
        <div class="b2b-scroll-list">
          <div
            v-for="(vendor, index) in filteredVendorList"
            :key="index"
            class="b2b-scroll-list__item"
            @click="selectVendor(vendor.pk)"
          >
            <p class="font-bold">{{ vendor.name }} - {{ vendor.id }}</p>
            <p v-if="vendor.notes" class="italic mt-1">{{ vendor.notes }}</p>
          </div>
        </div>
      </div>
      <pdl-callout v-else id="vendorSelectorDropdown_emptyState">
        <template #content>
          <span v-html="bp('noneFound')" />
        </template>
      </pdl-callout>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import SectionHeader from '@/components/SectionHeader';
import Heading from '@/components/Heading';
import {PdlCallout} from '@pedal/pdl-callout';
import axios from 'axios';

export default {
  components: {SectionHeader, Heading, PdlCallout},

  props: {
    baseProperties: {
      type: Array,
      default: () => [],
    },
    initialCurrentVendorPk: {
      type: String,
      default: null,
    },
    vendorList: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      currentVendorPk: this.initialCurrentVendorPk,
      search: '',
      // This can be used to control when the Search Box appears on the modal depending
      // on how many vendors there are
      searchDisplayThreshold: 2,
    };
  },

  computed: {
    currentVendorName() {
      if (Array.isArray(this.vendorList) && this.currentVendorPk) {
        const vendorFound = this.vendorList.find((vendor) => vendor.pk === this.currentVendorPk);
        return vendorFound ? vendorFound.name : vendorFound.id;
      }

      return null;
    },

    filteredVendorList() {
      if (typeof this.search === 'string' && this.search.length && Array.isArray(this.vendorList)) {
        return this.vendorList.filter((vendor) =>
          `${vendor.name} - ${vendor.id}`.toLowerCase().includes(this.search.toLowerCase())
        );
      } else {
        return this.vendorList;
      }
    },

    ...mapState('backend', ['encodedContextPath']),
  },

  methods: {
    selectVendor(pk) {
      if (this.currentVendorPk === pk) return;
      this.currentVendorPk = pk;
      this.$nextTick(async () => {
        await axios.post('/my-account/setVendor', new URLSearchParams({vendorPk: this.currentVendorPk}));

        if (location.pathname === `${this.encodedContextPath}/`) {
          location.reload();
        } else {
          location.replace(this.encodedContextPath);
        }

        this.$refs.vendorSelectorToggle._tippy.hide();
      });
    },
  },
};
</script>
